<template>
  <pulldown-page
    class=""
    background="#F7F7F7"
    :refresh="onRefresh"
    color="#333333"
    :isScroll='true'
  >
    <div class="middle-pvip-container">
      <div class="section-vip">
        <header>
          <div class="animation-wapper">
            <lottie ref="animataion" :options="showGif"/>
          </div>
          <template v-if="isVip===0">
            <p class="text-wait">等待审核</p>
            <p class="text-content">借款申请排队中，当前等待人数较多当前需等待{{waitTime}}分钟左右</p>
          </template>
          <template v-else-if="isVip===1">
            <p class="text-wait">激活中</p>
            <p class="text-content">小美VIP激活中，请耐心等待</p>
          </template>
        </header>
        <main>
          <img class="progress" src="./image/img_tisu@2x.png"/>
          <nd-button class="activate" @click="activation" :disabled="!!isVip">{{isVip?'激活中':'激活VIP免排队'}}</nd-button>
          <div class="give-up" @click="giveUp" v-if="!isVip">放弃排队</div>
        </main>
        <footer v-if="!isVip" @click="jumpVIP">
          <span class="text">小美VIP会员</span>
          <img src="./image/img_vip@2x.png"/>
        </footer>
        <!-- 购买会员类型选择 -->
        <nd-dialog
          v-model="dialog"
          :footer="false"
          closeBtn
          class="activity-dialog"
        >
          <div class="activity-template-content">
            <div class="radio-container">
              <div :class="['item left-radius', {active: checkItem===1}]" @click="check(1)">小美轻享VIP</div>
              <div :class="['item right-radius', {active: checkItem===0}]" @click="check(0)">小美尊享VIP</div>
            </div>
            <div class="middle-bg">
              <div class="content">
                <p>现在开通小美VIP会员，畅享提速通道！</p>
              </div>
              <div class="vips">
                <div
                  @click="active=item.memberGoodsCd"
                  :class="['item', {active: item.memberGoodsCd === active }]"
                  v-for="(item,index) in vipList"
                  :key="index"
                >
                  <img
                    :src="iconVip"
                    class="vipIcon"
                  >
                  <p>
                    {{vipType[item.memberGoodsCd]}} ￥{{item.discountPrice}}<br>
                    <span class="line-through yj">原价￥{{item.price}}</span>
                  </p>
                </div>
              </div>
              <div class="check-more" @click="$router.push('/vip/preindex?stash=true')">查看更多></div>
            </div>
            <div class="button-group">
              <nd-button
                class="btn"
                @click="buy()"
              >立即购买 </nd-button>
              <div class="xy-tips">开通即同意 <span
                class="active"
                @click="routerToVipProtocol"
              >《小美VIP会员协议》</span> </div>

            </div>
          </div>
        </nd-dialog>
        <!-- 弹窗/有会员状态在支付中 -->
        <nd-dialog
          v-model="continueDialog"
          :footer="false"
          closeBtn
          class="activity-dialog "
        >
          <div class="activity-template-content ">
            <div class="title">温馨提示</div>
            <div class="content">
              <p>您有一笔未完成的{{vipType[payStatusInfo.goodsCd]}}VIP支付交易</p>
            </div>
            <div class="button-group">
              <nd-button
                class="btn"
                @click="jump(payStatusInfo.goodsCd,'continue')"
              >继续支付</nd-button>
              <div
                class="giveup-btn"
                @click='giveup'
              >放弃支付 </div>
            </div>
          </div>
        </nd-dialog>
      </div>
    </div>
  </pulldown-page>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { Base64 } from 'js-base64'
import Lottie from 'vue-lottie'
import { getKey, judgeClientSystem } from '../../assets/utils'
import { generateUUID } from '../../services/stat'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import iconVip from './image/icon_vip.png'
import { wait } from '@/assets/json/index'
import qs from 'qs'
const deviceInfo = {
  terminal: getKey('terminal') || 'H5',
  appVersion: getKey('appVersion'),
  uuid: generateUUID()
}
export default {
  name: 'withdraw-middle-two',
  data () {
    return {
      iconVip,
      isVip: null, // 当前用户是否是vip
      active: 'LC_HY', // 卡时限
      dialog: false, // 购买会员类型选择
      continueDialog: false, // 弹窗/有会员状态在支付中
      payStatusInfo: {}, // 订单数据
      checkItem: 1, // 卡种
      vipInfo: {}, // 清享vip数据
      svipInfo: {}, // 尊享vip数据
      vipType: {
        BC_HY: '半年卡',
        BC_M: '月卡',
        BC_Y: '年卡',
        EC_HY: '半年卡',
        EC_M: '月卡',
        EC_Y: '年卡',
        LC_HY: '半年卡',
        LC_M: '月卡',
        LC_Y: '年卡'
      },
      showGif: { animationData: wait }, // 等待动效
      loanApplyNo: this.$route.query.loanApplyNo || '',
      waitTime: 0, // 等待时间
      timer: null // 计时器
    }
  },
  components: {
    'lottie': Lottie
  },
  computed: {
    vipList () {
      return this.checkItem === 1 ? this.vipInfo : this.svipInfo
    },
    ...mapState({
      equityList: (state) =>
        state.caseList.filter((item) => item.showType === 'MEMBER')
    })
  },
  watch: {
    checkItem (val) {
      if (val === 0) {
        this.active = 'EC_M'
      } else {
        this.active = 'LC_M'
      }
    }
  },
  beforeRouteLeave (to, form, next) {
    clearInterval(this.timer)
    next((vm) => {
    })
  },
  async created () {
    this.timer = setInterval(() => {
      this.init()
    }, 10000)
    await Promise.all([this.init(), this.waitVipX(), this.getCaseListX({ loanPlatform: 'TMD' }), this.getGoodsInfo('ENJOY'), this.getGoodsInfo('LIGHT_ENJOY')])
    this.$report({
      id: 10002,
      args: {
        screen: 'withdraw-middle-two',
        target: this.isVip ? 'vip' : 'novip'
      }
    })
    this.$bus.$emit('ready')
  },
     
  methods: {
    ...mapActions('vip', [
      'memberInfo',
      'groupInfo',
      'popInfo',
      'goodsInfo',
      'orderList',
      'orderCancel'
    ]),
    ...mapActions(['getCaseListX']),
    ...mapActions('withdraw', [
      'giveUpQueuinig',
      'waitVip',
      'getLoanResultX'
    ]),
    ...mapMutations('user', ['setUserInfo']),
    // 跳转vip界面
    jumpVIP () {
      this.$router.push({ path: '/vip/index' })
    },
    // 激活
    activation () {
      this.$report({
        id: 10272,
        args: {
        }
      })
      this.dialog = true
    },
    // 获取等待时间
    async waitVipX () {
      const { success, data } = await this.waitVip()
      if (success) {
        this.waitTime = data.waitTime
      }
    },
    // 下拉刷新
    onRefresh () {
      this.init()
    },
    // 放弃排队
    async giveUp () {
      if (!this.isVip) {
        const { success } = await this.giveUpQueuinig({ loanApplyNo: this.loanApplyNo })
        if (success) {
          this.$router.replace(`/withdraw/result?loanApplyNo=${this.loanApplyNo}`)
        }
      }
    },
    // 选择卡种
    check (item) {
      this.$report({
        id: 10163,
        args: {
          position: item
        }
      })
      this.checkItem = item
    },
    // 购买
    async buy () {
      const res = await this.orderList({ Status: '' })
      if (res.success) {
        this.payStatusInfo = res.data || {}
        if (
          this.payStatusInfo &&
          this.payStatusInfo.payStatus &&
          this.payStatusInfo.payStatus === 'WAIT_PAY'
        ) {
          this.dialog = false
          this.continueDialog = true
        } else {
          this.jump()
        }
      }
    },
    async giveup () {
      const res = await this.orderCancel({
        orderNo: this.payStatusInfo.exPaySerialNo
      })
      if (res.success) {
        this.continueDialog = false
      }
    },
    jump (type, modeOfPayment) {
      let discountPriceValue = ''
      let mode = {}
      if (modeOfPayment === 'continue') {
        const { originalAmount, couponUseDetail, reducedAmount } = this.payStatusInfo || {}
        discountPriceValue = originalAmount
        mode = { couponUseDetail: JSON.stringify(couponUseDetail), modeType: 'continue', reducedAmount }
      }
      let { couponRecordId } = this.$route.query || ''
      const _item = this.vipList.find(item => item.memberGoodsCd === this.active)
      const memberGoodsGroupCd = this.checkItem === 1 ? 'LIGHT_ENJOY' : 'ENJOY'
      let host = encodeURIComponent(window.location.href)
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let device = Base64.encode(
        JSON.stringify(
          Object.assign({}, deviceInfo, {
            longitude: getKey('longitude') || '',
            latitude: getKey('latitude') || ''
          })
        )
      )
      const origin = process.env.VUE_APP_PAYURL
      const channel = getKey('channel') || ''
      const path = '/pay'
      const query = { 
        memberType: type || this.active, 
        memberGoodsGroupCd: type ? this.payStatusInfo.memberGoodsGroupCd : memberGoodsGroupCd, 
        discountPrice: discountPriceValue || _item.discountPrice,
        couponRecordId,
        host,
        gid,
        token,
        channel,
        device,
        ...mode
      }
      window.location.href = `${origin}${path}?${qs.stringify(query)}&refurl=${window.location.origin}`
      // this.$router.push(
      //   { path: '/vip/middle',
      //     query: { 
      //       memberType: type || this.active, 
      //       memberGoodsGroupCd: type ? this.payStatusInfo.memberGoodsGroupCd : memberGoodsGroupCd, 
      //       discountPrice: discountPriceValue || _item.discountPrice,
      //       couponRecordId,
      //       host,
      //       gid,
      //       token,
      //       device,
      //       ...mode
      //     } 
      //   }
      // )
    },
    async init () {
      const arr = await Promise.all([this.memberInfo(), this.getLoanResultX({ loanApplyNo: this.loanApplyNo })])
      if (arr[0] && arr[0].success) {
        this.isVip = (arr[0].data && (arr[0].data.memberStatus === 'NORMAL') ? 1 : 0)
      } 
      if (arr[1] && arr[1].success) {
        const { loanStatusVoEnum } = (arr[1] && arr[1].data) || {}
        if (loanStatusVoEnum !== 'LOAN_WAIT_VIP') {
          this.$router.replace(`/withdraw/result?loanApplyNo=${this.loanApplyNo}`)
        }
      }
    },
    async getGoodsInfo (type) {
      const res = await this.goodsInfo({
        memberGoodsGroupCd: type,
        productCode: 'TMD'
      })
      if (res.success && res.data) {
        if (type === 'ENJOY') {
          this.svipInfo = res.data
        } else {
          this.vipInfo = res.data
        }
      }
    },
    back () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        return jsBridge('exit')
      } else {
        this.$router.go(-1)
      }
    },
    routerToVipProtocol () {
      this.dialog = false
      this.$router.push('/protocol/vip')
    }
  }
}
</script>

<style lang="less" scope>
@import "../../assets/less/mixin.less";

.middle-pvip-container {
    padding:172px 0 80px;
  .line-through {
    text-decoration: line-through;
    &.yj {
      font-size: 20px;
      }
    }
    header{
        .animation-wapper {
            height: 210px;
            width: 210px;
            margin: 0 auto;
        }
        .text-wait{
            font-size: 42px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-top:20px;
            text-align: center;
        }
        .text-content{
            text-align: center;
            width: 416px;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            margin:15px auto 0;
        }
    }
    .grey{
        color: grey !important;
    }
    main{
        display: flex;
        flex-direction:column;
        align-items: center;
        margin-top:49px;
        .progress{
            width:670px;
            height:167px;
        }
        .activate{
            margin-top:53px;
            width: 460px;
            height: 80px;
            line-height:80px;
            background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
            border-radius: 40px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
        }
        .give-up{
            margin-top:60px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF4633;
        }
    }
    footer{
        margin-top:85px;
        >.text{
            padding-left:40px;
            font-size: 38px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
        }
        >img{
            display: block;
            margin:24px auto 0;
            width:670px;
            height:200px;
        }
    }
  .activity-dialog {
    border-radius: 30px;
    &.cat .default-content {
        &::after {
        content: "";
        position: absolute;
        width: 178px;
        height: 154px;
        background: url("./image/img_mao02.png") no-repeat;
        background-size: contain;
        top: -152px;
        left: 50%;
        transform: translateX(-50%);
        }
    }
    .default-content {
        background: linear-gradient(90deg, #fef6e4 0%, #fcd5ac 100%) !important;
        .activity-template-content {
        width: 620px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px;
        .radio-container{
            width:456px;
            display: flex;
            justify-content:space-between;
            align-items: center;
            text-align: center;
            .item{
                width: 228px;
                height: 66px;
                line-height: 66px;
                background: #F2CEA7;
            }
            .active{
                background: #D89A66;
            }
            >.left-radius{
                border-radius: 10px 0 0 10px;
            }
            >.right-radius{
                border-radius:0 10px 10px 0;
            }
        }
        .middle-bg{
            margin-top:22px;
            padding:26px 20px 24px;
            width: 570px;
            background-color: rgba(248,153,102,0.1);
            border-radius: 10px;
        }
        .title {
            font-size: 32px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #763e12;
            line-height: 45px;
            text-align: center;
        }
        .content {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763E12;
        }
        .btn {
            width: 440px;
            height: 74px;
            line-height: 74px;
            margin-top: 30px;
            background: linear-gradient(270deg, #d79663 0%, #e4b378 100%);
        }
        .giveup-btn {
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763e12;
            line-height: 40px;
            text-align: center;
            margin-top: 30px;
        }
        .xy-tips {
            color: #763e12;
            text-align: center;
            margin-top: 30px;
            .active {
            color: #763e12;
            text-decoration: underline;
            }
        }
        .vips {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 26px 0;
            .vipIcon {
            width: 64px;
            height: 24px;
            }
            .item {
            width: 154px;
            height: 200px;
            background: #fffceb;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            text-align: center;
            padding: 20px 0;
            border: 1px solid #fbbf7c;
            position: relative;
            &:after {
                content: "";
                position: absolute;
                right: -18px;
                bottom: -18px;
                width: 36px;
                height: 36px;
                background: url("./image/circle_b.png") no-repeat;
                background-size: 100% 100%;
            }
            p {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #763e12;
                line-height: 33px;
            }
            &.active {
                background: #fff2cb;
                border: 3px solid #fbbf7c;
                &:after {
                background-image: url("./image/circle_a.png");
                }
            }
            }
        }
        .check-more{
            text-align: right;
            width: 100%;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763E12;
            margin-top:14px;
        }
        .step {
            p {
            padding-bottom: 30px;
            i {
                background: #763e12;
                font-style: normal;
                width: 40px;
                height: 40px;
                line-height: 40px;
                display: inline-block;
                text-align: center;
                border-radius: 100%;
                color: #fffceb;
                position: relative;
                &.line::after {
                content: "";
                position: absolute;
                width: 2px;
                height: 20px;
                background: #d79663;
                font-size: 0;
                left: 50%;
                top: 45px;
                }
            }
            }
        }
        }
    }
    }
}
</style>